import LocalBranchMap from 'components/LocalBranchMap';
import FormTitle from 'components/PageLayout/FormTitle';
import { ButtonWithLoadingState } from 'components/curo-components/common/Button';
import useGetBranchGeocode from 'hooks/useGetBranchGeocode';

import styles from './EndPages.module.scss';

const PAGE_TITLE = 'Thank you for your interest.';
const getPageDescription = () => (
  <p className={styles.descriptionWrapper}>
    Our records indicate that you already have an open loan with Heights Finance or one of our
    affiliates. To discuss the status of your loan or to go over your loan options, please contact
    your branch where you opened your loan.
  </p>
);

const RefiApplicationInvalidPage = () => {
  const { branchPhone, branchStreet, branchCityStateZip, latLng, getDirection } =
    useGetBranchGeocode();

  const renderContent = () => {
    if (latLng?.lat && latLng.lng) {
      return (
        <div className={styles.rightContainer}>
          <LocalBranchMap
            lat={latLng?.lat}
            lng={latLng?.lng}
            branchCityStateZip={branchCityStateZip}
            branchPhone={branchPhone}
            branchStreet={branchStreet}
            branchHours="Hours: 8:30-5:30"
          />

          <ButtonWithLoadingState kind="primary" size="form" onClick={getDirection}>
            Get Directions
          </ButtonWithLoadingState>
        </div>
      );
    }
  };

  return (
    <div className={styles.withMapPageContainer}>
      <div>
        <FormTitle title={PAGE_TITLE} subTitle={getPageDescription()} />
      </div>

      {renderContent()}
    </div>
  );
};

export default RefiApplicationInvalidPage;
